import Skeleton from "react-loading-skeleton";

/**
 * Skeleton loader for the OfferCodesTab component.
 * Mirrors the layout with stats section and dropzone.
 */
export function OfferCodesTabSkeleton() {
	return (
		<>
			{/* Stats Section Skeleton */}
			<div className="mb-6 rounded-lg border border-base-content/10 p-4">
				<div className="flex items-center justify-between mb-3">
					<Skeleton width={140} height={20} />
				</div>
				<dl className="grid grid-cols-1 gap-4 sm:grid-cols-3">
					<div>
						<Skeleton width={100} height={14} className="mb-1" />
						<Skeleton width={40} height={20} />
					</div>
					<div>
						<Skeleton width={70} height={14} className="mb-1" />
						<Skeleton width={40} height={20} />
					</div>
					<div>
						<Skeleton width={80} height={14} className="mb-1" />
						<Skeleton width={40} height={20} />
					</div>
				</dl>
			</div>

			{/* Dropzone Skeleton */}
			<div className="flex flex-col items-center justify-center gap-4 rounded-lg border-2 border-dashed border-base-content/10 p-12">
				<Skeleton circle width={56} height={56} />
				<div className="text-center">
					<Skeleton width={140} height={18} className="mb-2" />
					<Skeleton width={280} height={14} />
				</div>
				<Skeleton width={120} height={36} borderRadius={8} />
			</div>
		</>
	);
}
